/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
export default class UserInfoService extends Service {
    constructor(axios) {
        super(axios);
    }
    /** Home Owner 정보 수정 */
    modifyHomeownerAccountInfo = (homeownerId, userAccountInfo) => {
        return this.patch(apiWrapper.managerApiV1(`/homeowners/${homeownerId}`), userAccountInfo);
    };
    /** Home Owner 정보 삭제 */
    deleteHomeownerAccountInfo = (homeownerId) => {
        return this.delete(apiWrapper.managerApiV1(`/homeowners/${homeownerId}`));
    };
}
